import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

export interface DatenverwaltungZertifizierungZuordnungProps {
    data: any;
}

export interface DatenverwaltungZertifizierungZuordnungState {
    bundle: any;
    zertifizierungsoptionen: any;
}

export class DatenverwaltungZertifizierungZuordnung extends
    React.Component<DatenverwaltungZertifizierungZuordnungProps, DatenverwaltungZertifizierungZuordnungState> {

    constructor(props: any) {
        super(props);
        this.state = {
            bundle: null,
            zertifizierungsoptionen: null
        };
        this.customFormatter = this.customFormatter.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        this.init();
    }

    customFormatter(field: string, value: any, data: any, row: any): any {
        value = typeof value === 'number'
            ? (((this.props.data || {})[IDs.ENT_ZERTIFIZIERUNGSOPTIONEN] || []).find((item: any) => item.tid === value) || {}).name || null
            : value;
        return field === 'zertifizierung' && ((this.state.zertifizierungsoptionen || {})[value] || []).length > 1
            ? `${value} (${this.state.zertifizierungsoptionen[value].indexOf(data.zertifizierung_orig || data.zertifizierung) + 1})`
            : value;
    }

    init(): void {
        const data: any = {};
        const zertifizierung: any[] = [];

        ((this.props.data || {})[IDs.ENT_ZERTIFIZIERUNGSOPTIONEN] || [])
            .sort((a: any, b: any) => a.tid - b.tid)
            .forEach((item: any) => {
                if (typeof data[item.name] === 'undefined') {
                    data[item.name] = [];
                }
                data[item.name].push(item.tid);
            });

        ((this.props.data || {})[IDs.ENT_ZERTIFIZIERUNGSOPTIONEN] || []).forEach((item: any, index: number) => {
            const name: string = item.name || null;
            zertifizierung.push(item);
            zertifizierung[index].name = data[name].length > 1
                ? `${name} (${data[name].indexOf(item.tid) + 1})`
                : name;
        });
        this.setState({ bundle: { zertifizierung }, zertifizierungsoptionen: data });
    }

    render(): JSX.Element {
        if (!this.state.bundle) {
            return null;
        }

        return (
            <WFormsTableWrapper
                entity={IDs.ENT_ZERTIFIZIERUNG_ZUORDNUNG}
                module={IDs.MOD_ETOOL_ADMIN}
                actions={['add', 'edit', 'delete']}
                formLayout='flowV2'
                customClass='Custom-ETA'
                bundleFilterFunc={(bundle: any) => bundle.zertifizierung = this.state.bundle.zertifizierung || bundle.zertifizierung}
                onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_ZERTIFIZIERUNG_ZUORDNUNG)}
                customFormatter={this.customFormatter}
                showColumnsHelp
            />
        );
    }
}
